<template>
    <div class="container mt-nav z-index">
        <Head title="تایید کلمه عبور" />
        <div class="row">
            <div class="col-sm-10 col-lg-6  mx-auto">
                <div class="box__information">
                    <div class="col-12 col-md-10">
                        <p class="text-title text-white text-center pb-3">کد ارسالی به شماره {{data.mobile}} را وارد
                            کنید</p>
                        <template v-if="data.error"><div class="fs-5 alert alert-danger" role="alert">{{data.error}}</div></template>
                        <template v-if="data.success"><div class="fs-5 alert alert-success" role="alert">{{ data.success }}</div></template>

                        <form method="post" @click.prevent="storeVerifyCode()">
                            <div class="d-flex align-content-center justify-content-center mt-5 d-flex">
                                <input ref="code1" dir="ltr" class="my-3 verify_input order-4" maxlength="1" type="text" v-model="formVerify.code.code1" name="code1">
                                <input ref="code2" dir="ltr" class="my-3 verify_input order-3" maxlength="1" type="text" v-model="formVerify.code.code2" name="code2">
                                <input ref="code3" dir="ltr" class="my-3 verify_input order-2" maxlength="1" type="text" v-model="formVerify.code.code3" name="code3">
                                <input ref="code4" dir="ltr" class="my-3 verify_input order-1" maxlength="1" type="text" v-model="formVerify.code.code4" name="code4">

                            </div>
                            <div class="text-center mt-5">
                                <a v-if="sendAgain" @click.prevent="sendAgainCode()" class=" text-lg text-dark-gray"
                                   href="">ارسال مجدد کد</a>
                                <p v-if="!sendAgain" class="m-0 time text-white text-lg"><span
                                    class="countdowner">{{ countDown }}</span></p>
                            </div>
                            <div class="mt-5 text-center">
                                <loading-button :loading="formVerify.processing" class="btn btn-orange hover_button w-100-btn"
                                                type="submit">ثبت کد
                                </loading-button>

                            </div>

                            <div class="mt-5 text-center">
                                <button @click.prevent="changeMobile" class="btn btn-outline-orange hover_button w-100-btn mx-auto">
                                    تغییر شماره موبایل
                                    <span class="reply me-2"></span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {Head} from '@inertiajs/inertia-vue3'
import LayoutFirstRegister from "../../Shared/Layouts/LayoutFirstRegister";
import {Link} from "@inertiajs/inertia-vue3";
import TextInput from "../../Shared/Forms/TextInput";
import LoadingButton from "../../Shared/Layouts/LoadingButton";

export default {
    props: {
        data: {
            type: Array,
        },
    },
    components: {
        TextInput,
        LoadingButton,
        Head,
    },
    layout: LayoutFirstRegister,
    data() {
        return {
            form: this.$inertia.form({
                verifyCode1: '',
            }),
            sendAgain: false,
            countDown: 60,

            formVerify: this.$inertia.form({
                mobile: this.data.mobile,
                code : {
                    code1: '',
                    code2: '',
                    code3: '',
                    code4: '',
                }
            }),
        }
    },
    watch: {
        "formVerify.code.code1": function(newVal, previousVal) {
            if (newVal.length > 0){
                this.$refs.code2.focus();
            }
        },
        "formVerify.code.code2": function(newVal, previousVal) {
            if (newVal.length > 0){
                this.$refs.code3.focus();
            } else {
                this.$refs.code1.focus();
            }
        },
        "formVerify.code.code3": function(newVal, previousVal) {
            if (newVal.length > 0){
                this.$refs.code4.focus();
            } else {
                this.$refs.code2.focus();
            }
        },
        "formVerify.code.code4": function(newVal, previousVal) {
            if (newVal.length > 0){
                this.store();
            } else {
                this.$refs.code3.focus();
            }
        },


    },
    methods: {
        resetForm(){
            this.formVerify.code.code1 = this.formVerify.code.code2 = this.formVerify.code.code3 = this.formVerify.code.code4 = '';
        },
        changeMobile(){
            window.location.href = 'forget-password';
        },
        countDownTimer() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            } else {
                this.sendAgain = true;
            }
        },
        store() {
            this.formVerify.post('/store-verify-code', {
                onSuccess: (data) => {
                    this.resetForm();
                }
            })
        },
        storeSendAgain() {
            this.formVerify.post('/send-again', {
                onSuccess: (data) => {
                    this.sendAgain = false;
                    this.countDown = 60;
                    this.countDownTimer();
                }
            })
        },
        storeVerifyCode() {
            this.store();
            // this.resetForm();
        },
        sendAgainCode() {
            this.resetForm();
            this.storeSendAgain();
        },
    },
    created() {

    },
    mounted() {
        this.$refs.code1.focus();
        this.countDownTimer();
    },
    metaInfo() {
        return {
            meta: [
                {name: 'description', content: 'hello is my desd'}
            ]
        }

    }
}

</script>

<style scoped>

</style>
